import React from 'react';
import classNames from 'classnames';
import './SubTitle.scss';

const SubTitle = ({ title, rtl }) => {
  const classes = classNames({
    'nw-subTitle': true,
    'nw-subTitle--rtl': rtl,
  });
  return (
    <div className={classes}>
      <h3>{title}</h3>
    </div>
  );
};

export default SubTitle;
